import store from '@/core/store';
import { RouteRecordRaw } from 'vue-router';

const AiMatchingPage = () => import('@/modules/ai-matching/pages/AiMatchingPage.vue');

const AI_MATCHING_ROUTES: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'AiMatchingPage',
      component: AiMatchingPage,
      beforeEnter: (_to, _from, next) => {
         store.getters.isFeatureTester ? next() : next({ name: 'Forbidden' });
      },
   },
];

export { AI_MATCHING_ROUTES };
